import * as React from "react";
import Component from "../../AbstractComponent";
import Time from "../../../Time/Time";
import MomentUtils from '@date-io/moment';
import * as moment from "moment";
import Store from "../../../Store/Store";
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import {
  DatePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

class DatePickerComponent extends Component {
  protected locale = Store.getConfigurator().getState().app.settings.user.locale.iso;
  protected language = moment.locale(Store.getConfigurator().getState().app.settings.user.language.iso);

  public state = {
    minDate: null,
    maxDate: null,
    error: ""
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount(): any {
    let minDate: Date = new Date(0);

    if (!!this.props.minDate) {
      minDate = Time.addDays(this.props.minDate, this.props.minDatePlusDays);
    }

    this.setState({
      minDate: minDate,
      maxDate: this.props.maxDate,
      error: this.state.error || this.props.error
    });
  }

  public componentWillReceiveProps(nextProps) {
    let minDate: Date = new Date(0);

    if (!!nextProps.minDate) {
      minDate = Time.addDays(nextProps.minDate, nextProps.minDatePlusDays);
    }

    this.setState({
      minDate: minDate,
      maxDate: nextProps.maxDate,
      error: nextProps.error
    });
  }

  public onChange = (momentDate: moment.Moment, value?: string): void => {
    let date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    if (value === "__/__/____" || value === "__-__-____") {
      date = null;
    }

    if (typeof this.props.onChange !== "undefined" && ((date instanceof Date && !isNaN(Number(date))) || date === null)) {
      this.props.onChange.call(this, date);
    }
  }

  public render() {
    const format: string = this.locale === "en-US" ? "MM/DD/YYYY" : "DD-MM-YYYY";
    const formatHint: string = this.locale === "en-US" ? "MM/DD/YYYY" : "dd-mm-jjjj";

    return (
      <div
        style={{
          width: !!this.props.width ? this.props.width : "auto",
          height: this.props.height ? this.props.height : "auto",
          margin: this.props.margin ? this.props.margin : "0",
          position: "relative"
        }}>
        <MuiPickersUtilsProvider
          utils={MomentUtils}
          locale={this.language}
          libInstance={moment}
        >
          {
            this.props.disableKeyboard && (
              <DatePicker
                autoOk
                format={!!this.props.views ? undefined : format}
                clearable={!this.props.disabled && this.props.initialDate && this.props.clearButton}
                label={this.props.label}
                className={`form-element ${this.props.datePickerFromDialog ? 'form-element-dialog' : 'full-size'} datepicker datepicker-margin datepicker-filled-styles no-margin ` + this.props.className}
                value={this.props.initialDate}
                onChange={this.onChange}
                minDate={this.state.minDate}
                minDateMessage={this.props.minDateMessage || ""}
                maxDate={this.state.maxDate}
                maxDateMessage={this.props.maxDateMessage || ""}
                disabled={this.props.disabled}
                variant="dialog"
                openTo={this.props.openTo}
                views={this.props.views}
                error={!!this.state.error}
                invalidDateMessage={null}
                // inputVariant={this.props.inputVariant}
                inputVariant={"filled"}
              />
            )
          }
          {
            !this.props.disableKeyboard && (
              <KeyboardDatePicker
                autoOk
                placeholder={formatHint}
                format={!!this.props.views ? undefined : format}
                clearable={!this.props.disabled && this.props.initialDate && this.props.clearButton}
                label={this.props.label} 
                className={`form-element ${this.props.datePickerFromDialog ? 'form-element-dialog' : 'full-size'} datepicker datepicker-filled-styles no-margin ` + this.props.className}
                value={this.props.initialDate}
                onChange={this.onChange}
                minDate={this.state.minDate}
                minDateMessage={this.props.minDateMessage || ""}
                maxDate={this.state.maxDate}
                maxDateMessage={this.props.maxDateMessage || ""}
                disabled={this.props.disabled}
                variant="dialog"
                openTo={this.props.openTo}
                views={this.props.views}
                error={!!this.state.error}
                invalidDateMessage={null}
                // inputVariant={this.props.inputVariant}
                inputVariant={"filled"}
              />
            )
          }
          
      {/* {!!this.state.error && <div className={`datepicker-error ${this.props.additionClasses || ""}`}>{this.state.error}</div>} */}
          {!!this.props.error && <FormHelperText error={true} id="component-error-text">{this.props.error}</FormHelperText>}

          {!this.props.dialogPresentation && this.props.financialStatementId &&  (
            <IconButton className="icon-button-wrapper" style={{position: "absolute", right: "-42px", top: "10px", cursor: "pointer"}}>
              <div
                className="icon icon-ic-open-in-new" onClick={() => this.redirect(`/app/owner-statement/update/${this.props.financialStatementId}/`)}
              >
              </div>
            </IconButton>
          )}

          {/* {this.props.hint && (
            <p className="datepicker-hint">{this.props.hint}</p>
          )} */}
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

export { DatePickerComponent };
